<template>
  <Layout>
    <PageHead :pageHeadData="PageHeadData" HeadType="LTC" />
    <ProductOverview
      :summarizeTextList="summarizeTextList"
      :videoData="videoData"
    />
    <!-- 业务蓝图 -->
    <section
      class="rn-section-gap slider-bg-image"
      :style="{
        'background-image': `url(${require('@/assets/images/ProductService/common/business-blueprint.png')})`,
      }"
    >
      <SectionTitle
        :title="$t('product.business_blueprint')"
        description="BUSINESS BLUEPRINT"
        textAlign="center"
      />
      <div class="container">
        <LTCBusinessBlueprint />
      </div>
    </section>
    <ProductAbility :abilityData="AbilityData" abilityType="LTC" />
    <ProductSuperiority :productSuperiorityData="ProductSuperiorityData" />
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Separator from '../../components/elements/separator/Separator'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import ProductOverview from './components/ProductOverview.vue'
import LTCBusinessBlueprint from './components/BusinessBlueprint/LTCBusinessBlueprint.vue'
import ProductAbility from './components/ProductAbility.vue'
import PageHead from './components/PageHead.vue'
import ProductSuperiority from './components/ProductSuperiority/ProductSuperiority.vue'
import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
import {
  LTC_icon01,
  LTC_icon02,
  LTC_icon03,
  LTC_icon04,
  numImage01,
  numImage02,
  numImage03,
  numImage04,
  numImage05,
  numImage06,
  zhongtongBackground,
  HITACHIBackground,
  YTOBackground,
  HITACHIIcon,
  TCLIcon,
  ChianxinIcon,
  JinJiangIcon,
  DeltaIcon,
  LenovoIcon,
  VERTIVIcon,
  AUXIcon,
  A0SMITHIcon,
  WEICHAIIcon,
  H3CIcon,
  zhongtongIcon,
  JinTianGroupIcon,
  TongDingIcon,
  GRGBankingIcon,
  ChambroadIcon,
  ShengHongIcon,
  SunGrowIcon,
  LTCAbility01,
  LTCAbility02,
  LTCAbility03,
  LTCAbility04,
  LTCAbility05,
  LTCAbility06,
  LTCAbility07,
  LTCAbility08
} from './Image.js'

export default {
  name: 'VyungLTC',
  components: {
    Layout, Separator, SectionTitle,
    ProductOverview, LTCBusinessBlueprint, ProductAbility, PageHead, ProductSuperiority, ClassicCases,
  },
  data () {
    return {
      //页面头部
      PageHeadData: {
        engTitle: 'Lead To Cash',
        text: this.$t('product.VyungLTC.head.text'),
        subtitle: this.$t('product.VyungLTC.head.subtitle'),
        image: require('@/assets/images/ProductService/VyungLTC/LTC-Image.png'),
      },
      //产品概述
      videoData: [{
        src:process.env.VUE_APP_VIDEO_URL+'/$web/video/product_ltc.mp4?'+process.env.VUE_APP_VIDEO_RAXWDL,
        thumb: require(`@/assets/images/ProductService/VyungLTC/ltc_tumb.jpg`)
      }],
      summarizeTextList: {
        text01: this.$t('product.VyungLTC.product_overview.text01'),
        text02: this.$t('product.VyungLTC.product_overview.text02')
      },
      //产品功能
      AbilityData: [
        {
          title: this.$t('product.VyungLTC.product_ability.card01.title'),
          text: this.$t('product.VyungLTC.product_ability.card01.text'),
          contentImage: LTCAbility01,
          numImage: numImage01,
        },
        {
          title: this.$t('product.VyungLTC.product_ability.card02.title'),
          text: this.$t('product.VyungLTC.product_ability.card02.text'),
          contentImage: LTCAbility02,
          numImage: numImage02,
        },
        {
          title: this.$t('product.VyungLTC.product_ability.card03.title'),
          text: this.$t('product.VyungLTC.product_ability.card03.text'),
          contentImage: LTCAbility03,
          numImage: numImage03,
        },
        {
          title: this.$t('product.VyungLTC.product_ability.card04.title'),
          text: this.$t('product.VyungLTC.product_ability.card04.text'),
          contentImage: LTCAbility04,
          numImage: numImage04,
        },
        {
          title: this.$t('product.VyungLTC.product_ability.card05.title'),
          text: [{
            subtext: this.$t('product.VyungLTC.product_ability.card05.text[0].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card05.text[1].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card05.text[2].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card05.text[3].subtext'),
          }],
          contentImage: [
            LTCAbility05,
            LTCAbility06,
            LTCAbility07,
          ],
          numImage: numImage05,
        },
        {
          title: this.$t('product.VyungLTC.product_ability.card06.title'),
          text: [{
            subtext: this.$t('product.VyungLTC.product_ability.card06.text[0].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card06.text[1].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card06.text[2].subtext'),
          }, {
            subtext: this.$t('product.VyungLTC.product_ability.card06.text[3].subtext'),
          }],
          contentImage: LTCAbility08,
          numImage: numImage06,
        },
      ],

      //产品优势
      ProductSuperiorityData: [
        {
          title: this.$t('product.VyungLTC.product_advangtages.card01.title'),
          text: this.$t('product.VyungLTC.product_advangtages.card01.text'),
          contentImage: LTC_icon01,
        },
        {
          title: this.$t('product.VyungLTC.product_advangtages.card02.title'),
          text: this.$t('product.VyungLTC.product_advangtages.card02.text'),
          contentImage: LTC_icon02,
        },
        {
          title: this.$t('product.VyungLTC.product_advangtages.card03.title'),
          text: this.$t('product.VyungLTC.product_advangtages.card03.text'),
          contentImage: LTC_icon03,
        },
        {
          title: this.$t('product.VyungLTC.product_advangtages.card04.title'),
          text: this.$t('product.VyungLTC.product_advangtages.card04.text'),
          contentImage: LTC_icon04,
        }
      ],

      //产品案例
      ClassicCasesData: [
        {
          // imageBackground: HITACHIBackground,
          brandIcon: HITACHIIcon,
        }, {
          // imageBackground: zhongtongBackground,
          brandIcon: TCLIcon,
        }, {
          brandIcon: ChianxinIcon,
        }, {
          brandIcon: JinJiangIcon,
        }, {
          brandIcon: DeltaIcon,
        }, {
          brandIcon: LenovoIcon,
        }, {
          brandIcon: VERTIVIcon,
        }, {
          brandIcon: AUXIcon,
        }, {
          brandIcon: A0SMITHIcon,
        }, {
          brandIcon: WEICHAIIcon,
        }, {
          brandIcon: H3CIcon,
        }, {
          brandIcon: zhongtongIcon,
        }, {
          brandIcon: JinTianGroupIcon,
        }, {
          brandIcon: TongDingIcon,
        }, {
          brandIcon: GRGBankingIcon,
        }, {
          brandIcon: ChambroadIcon,
        }, {
          brandIcon: ShengHongIcon,
        }, {
          brandIcon: SunGrowIcon,
        },
      ]
    }
  },
  methods: {
  
  }
}
</script>